import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoHeader } from '@/components/SeoHeader';
import { Layout } from '@/components/layout';
import { HeroWithBreadcrumbs } from '@/sections/HeroWithBreadcrumbs';
import { getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { Faq } from '@/sections/aboutUs/Faq';
import { MoreInfo } from '@/sections/aboutUs/MoreInfo';
import { useGetNewestPressReleasesQuery } from '@/api/sanity/generated';
import { ArticleBox, ArticleBoxProps } from '@/components/boxes';
import { LINKS } from '@/constants/links';
import { mapPressReleasesToArticles } from '@/sections/pressReleases/mapPressReleasesToArticles';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { sanityLanguage } from '@/constants/language';
interface Props {
  pressReleasesArticles: ArticleBoxProps[];
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function WroteAboutUs(t0) {
  const $ = _c(40);
  const {
    pressReleasesArticles,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["forJournalists", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  usePageView("press-releases");
  let t2;
  if ($[1] !== t) {
    t2 = t("seoList.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seoList.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = LINKS();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = {
      title: t5,
      to: t6.forMedia
    };
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("pressReleasesSection.title");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = {
      title: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = [t7, t9];
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("pressReleasesSection.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <SectionHeadline variant="inverted" anchorKey="pressReleasesSection.title">{t11}</SectionHeadline>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== pressReleasesArticles) {
    t13 = pressReleasesArticles.map(_temp);
    $[24] = pressReleasesArticles;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <div className="mx-auto grid max-w-292 gap-2 py-12 md:grid-cols-2 md:gap-8 lg:grid-cols-3 xl:py-16">{t13}</div>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t14) {
    t15 = <HeroWithBreadcrumbs breadcrumbs={t10} circleClassName="w-[25rem] h-[25rem] lg:w-[76rem] lg:h-[76rem] left-0 top-0 -translate-x-1/3 -translate-y-1/3 rotate-180">{t12}{t14}</HeroWithBreadcrumbs>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SectionDelimiter color="bg-blue-50" background="bg-blue-900" />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="relative overflow-hidden bg-blue-50 py-10 lg:py-20"><div className="relative z-10 flex flex-col gap-20 lg:gap-40"><Faq /><MoreInfo /></div><div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" /></div>;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15) {
    t18 = <div className="relative overflow-x-hidden">{t15}{t16}{t17}</div>;
    $[34] = t15;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== menuPromoBanners || $[37] !== t18 || $[38] !== t4) {
    t19 = <Layout variant="inverted" menuPromoBanners={menuPromoBanners}>{t4}{t18}</Layout>;
    $[36] = menuPromoBanners;
    $[37] = t18;
    $[38] = t4;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}
function _temp(article) {
  return <ArticleBox {...article} key={article.link.toString()} />;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('tiskove-zpravy');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  const fetchPressReleases = useGetNewestPressReleasesQuery.fetcher({
    i18nLang: sanityLanguage
  });
  const pressReleasesData = await fetchPressReleases();
  const pressReleasesArticles = pressReleasesData.allPressRelease && pressReleasesData.allPressRelease?.length > 0 && mapPressReleasesToArticles(pressReleasesData.allPressRelease?.map(item => ({
    ...item,
    name: item?.name || '',
    slug: {
      current: item?.slug?.current || ''
    }
  }))).filter(Boolean) || [];
  const intlProps = await getIntlProps(ctx, ['core', 'aboutUs', 'testimonials', 'forJournalists']);
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      pressReleasesArticles,
      ...intlProps
    }
  };
}) satisfies GetStaticProps<Props>;